import axios from "axios"
import { convertPermission } from "permissionUtils"
import React, { useEffect, useState, useRef } from "react"
import { useHistory } from "react-router-dom"
import { Input, Row, Col } from "reactstrap"

const FilterReports = ({ filteredValues, setFilteredValues, setAuth }) => {
  const history = useHistory()

  const debounceTimeout = useRef(null)

  const [users, setUsers] = useState([])

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/MenuUsersView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        data.splice(-1)
        // let dataUsers = data.map(
        //   user => `${user[1].FirstName} ${user[1].LastName} - ${user[1].UserID}`
        // )
        // setUsers(dataUsers.sort())
        let usersArray = data.map(user => ({
          label: `${user[1].FirstName} ${user[1].LastName}`,
          value: user[1].UserID,
        }))
        setUsers(usersArray)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const filteredFeatures = [
    "Reference No.",
    "Request No.",
    "Date",
    "User",
    // "Type",
    "Status",
  ]
  const statusOptions = [
    "Pending",
    "Approved",
    "Rejected",
    "Manual",
    "Out_Of_RDAPP",
    "Missing Data",
    "Manger Approval",
    "Under Review",
    "Edit Required",
    "InProgress",
  ]

  return (
    <>
      <Row className="d-flex col-11">
        <Col sm={3}>
          {/* ******************************* Reference No *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="number"
                className="border-0"
                placeholder="Reference No ..."
                onChange={e => {
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current)
                  }

                  debounceTimeout.current = setTimeout(() => {
                    setFilteredValues({
                      ...filteredValues,
                      ReferenceNo: e.target.value,
                    })
                  }, 1000)
                }}
              />
            </div>
          </div>

          {/* ******************************* Policy No *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="number"
                className="border-0"
                placeholder="Policy No ..."
                onChange={e => {
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current)
                  }

                  debounceTimeout.current = setTimeout(() => {
                    setFilteredValues({
                      ...filteredValues,
                      PolicyNo: e.target.value,
                    })
                  }, 1000)
                }}
              />
            </div>
          </div>
        </Col>

        <Col sm={3}>
          {/* ******************************* Request No *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="number"
                className="border-0"
                placeholder="Request No ..."
                onChange={e => {
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current)
                  }

                  debounceTimeout.current = setTimeout(() => {
                    setFilteredValues({
                      ...filteredValues,
                      RequestID: e.target.value,
                    })
                  }, 1000)
                }}
              />
            </div>
          </div>

          {/* ******************************* Areal Decision No *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="number"
                className="border-0"
                placeholder="Survey Resolution No ..."
                onChange={e => {
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current)
                  }

                  debounceTimeout.current = setTimeout(() => {
                    setFilteredValues({
                      ...filteredValues,
                      ArealDecisionNo: e.target.value,
                    })
                  }, 1000)
                }}
              />
            </div>
          </div>
        </Col>

        <Col sm={3}>
          {/* ******************************* Status *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="select"
                name="status"
                onChange={e => {
                  setFilteredValues({
                    ...filteredValues,
                    Status: e.target.value,
                  })
                }}
                className="border-0"
              >
                <option selected value="">
                  Status...
                </option>
                {statusOptions.map((status, i) => (
                  <option key={i} value={status}>
                    {status}
                  </option>
                ))}
              </Input>
            </div>
          </div>

          {/* ******************************* User *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="select"
                name="user"
                className="border-0"
                onChange={e => {
                  // console.log("------------------", e.target.value)
                  setFilteredValues({
                    ...filteredValues,
                    User: e.target.value,
                  })
                }}
              >
                <option selected value="">
                  User ...
                </option>
                {users.map((user, i) => (
                  <option key={i} value={user.value}>
                    {user.label}
                  </option>
                ))}
              </Input>
            </div>
          </div>
        </Col>

        <Col sm={3}>
          {/* ******************************* Date *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="date"
                className="border-0"
                placeholder="Date ..."
                onChange={e => {
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current)
                  }

                  debounceTimeout.current = setTimeout(() => {
                    setFilteredValues(prev => ({
                      ...prev,
                      Date: e.target.value,
                    }))
                  }, 1000)
                }}
              />
            </div>
          </div>
        </Col>
      </Row>

      {/* <div className="d-flex justify-content-center col-11">
        {filteredFeatures.map((feature, i) =>
          feature === "Status" ? (
            <div
              className="d-flex col-2 justify-content-start mb-2 mx-1"
              key={i}
            >
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type="select"
                    name="status"
                    onChange={e => {
                      // console.log(e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        Status: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  >
                    <option selected value="">
                      Status...
                    </option>
                    {statusOptions.map((status, i) => (
                      <option key={i} value={status}>
                        {status}
                      </option>
                    ))}
                  </Input>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "User" ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex col-12">
                  <input
                    list="usersList"
                    placeholder="User..."
                    name="user"
                    onChange={e => {
                      // console.log("user =====>", e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        User: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                    disabled={userPermissions.R3.G !== "1"}
                  />
                  <datalist id="usersList">
                    {users.map((user, i) => (
                      <option key={i} value={user} />
                    ))}
                  </datalist>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : (
            <div
              key={i}
              className="d-flex col-2 justify-content-start mb-2 mx-1"
            >
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type={
                      feature === "Reference No." || feature === "Request No."
                        ? "number"
                        : feature === "Date"
                        ? "date"
                        : "text"
                    }
                    className="form-control border-dark"
                    placeholder={feature}
                    onChange={e => {
                      let updatedObject = {}

                      if (debounceTimeout.current) {
                        clearTimeout(debounceTimeout.current)
                      }

                      debounceTimeout.current = setTimeout(() => {
                        feature === "Reference No."
                          ? (updatedObject["ReferenceNo"] = e.target.value)
                          : feature === "Request No."
                          ? (updatedObject["RequestID"] = e.target.value)
                          : (updatedObject[feature] = e.target.value)

                        setFilteredValues({
                          ...filteredValues,
                          ...updatedObject,
                        })
                      }, 1000)
                    }}
                  />
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          )
        )}
      </div> */}
    </>
  )
}

export default FilterReports
